import { MOBILE_APP_CONFIG, USER_AGENT_PATTERNS } from '../config/constants';

export const MOBILE_APP_SCHEME = MOBILE_APP_CONFIG.SCHEME;

export const isMobileDevice = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return USER_AGENT_PATTERNS.MOBILE_DEVICES.test(userAgent);
};

export const openInMobileApp = async (options?: { itmSource?: string }): Promise<boolean> => {
  // Check if user is on mobile device
  if (!isMobileDevice()) {
    return false;
  }

  // Convert current web path directly to mobile deep link (same structure)
  const currentPath = window.location.pathname;
  const itmSource = options?.itmSource ?? 'share';
  const deepLink = `${MOBILE_APP_SCHEME}${currentPath}?itmSource=${itmSource}`;
  
  // Try to open the mobile app
  window.location.href = deepLink;
  
  // Simple approach: wait for user to return from app or timeout
  return new Promise((resolve) => {
    let hasHidden = false;
    let hasResolved = false;
    
    const handleVisibilityChange = () => {
      if (document.hidden) {
        hasHidden = true;
      } else if (hasHidden && !hasResolved) {
        // User returned from somewhere (likely the app)
        hasResolved = true;
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        resolve(true); // App opened successfully
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // If page never becomes hidden, no app installed
    setTimeout(() => {
      if (!hasHidden && !hasResolved) {
        hasResolved = true;
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        resolve(false);
      }
    }, 1000);
  });
};

const buildAndroidReferrerUrl = (deepLinkUrl: string): string => {
  const base = MOBILE_APP_CONFIG.APP_STORE.ANDROID;
  const referrerPayload = new URLSearchParams({ 
    deep_link: deepLinkUrl, 
    utm_source: 'web', 
    utm_medium: 'android' 
  }).toString();
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}referrer=${encodeURIComponent(referrerPayload)}`;
};

export const getDeferredInstallUrlForCurrentPage = (
  platform: 'android' | 'ios',
  options?: { itmSource?: string }
): string => {
  if (typeof window === 'undefined') {
    return platform === 'android' ? MOBILE_APP_CONFIG.APP_STORE.ANDROID : MOBILE_APP_CONFIG.APP_STORE.IOS;
  }

  const currentPath = window.location.pathname;
  const itmSource = options?.itmSource ?? 'store';
  
  if (platform === 'android') {
    // Convert current web path directly to mobile deep link
    const deepLink = `${MOBILE_APP_SCHEME}${currentPath}?itmSource=${itmSource}`;
    return buildAndroidReferrerUrl(deepLink);
  }

  // iOS: plain App Store URL (no deferred deep linking for now)
  return MOBILE_APP_CONFIG.APP_STORE.IOS;
};


